import { TicketMessageChannel } from 'flow/types/Tickets';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectTicketAttachmentMaxSize } from 'flow/selectors/TicketsSelectors';
import { getMidPhraseChanneli18Key } from './FileTypeNotAllowed';

interface FileTooLargeProps {
    channel?: TicketMessageChannel;
    mimeType?: string;
}

const FileTooLarge = ({ channel, mimeType }: FileTooLargeProps) => {
    const { i18next } = useAppContext();

    const channeli18Key = getMidPhraseChanneli18Key(channel);
    const maxSizeAllowed = useAppSelector((state) =>
        selectTicketAttachmentMaxSize(state, channel, mimeType),
    );

    if (!channeli18Key) return i18next.t('chat.attachment.size_exceeded');

    const i18nKey = getFileTooLargei18Key(mimeType);
    if (!i18nKey) return i18next.t('chat.attachment.size_exceeded');

    return i18next.t(i18nKey, {
        channel: i18next.t(channeli18Key),
        size: getBytesInMB(maxSizeAllowed),
    });
};

export default FileTooLarge;

const getFileTooLargei18Key = (mimeType?: string) => {
    if (!mimeType) return '';
    switch (true) {
        case mimeType.startsWith('image'):
            return 'tickets.input.attachment.too_large.image';
        case mimeType.startsWith('video'):
            return 'tickets.input.attachment.too_large.video';
        case mimeType.startsWith('audio'):
            return 'tickets.input.attachment.too_large.audio';
        case mimeType.startsWith('application') || mimeType.startsWith('text'):
            return 'tickets.input.attachment.too_large.document';
        default:
            return '';
    }
};

const getBytesInMB = (sizeInBytes: number) =>
    (sizeInBytes / (1024 * 1024))?.toFixed(0);
